import { render, staticRenderFns } from "./TicketOverView.vue?vue&type=template&id=19becf96&scoped=true&"
import script from "./TicketOverView.vue?vue&type=script&lang=js&"
export * from "./TicketOverView.vue?vue&type=script&lang=js&"
import style0 from "./TicketOverView.vue?vue&type=style&index=0&id=19becf96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19becf96",
  null
  
)

export default component.exports